// extracted by mini-css-extract-plugin
export default {"content":"style_content__E49gM","itemName":"style_itemName__A4trk"};